__webpack_require__.p = "/periodic-table/";